export default __webpack_public_path__ + "static/media/Banner - AirDockz - Pink.21468194.jpg";